function toggleIntercom() {
  const iframedInSeismic = sessionStorage.getItem('iframedInSeismic');
  if (window.Intercom) {
    if (
      document.querySelectorAll('.hide-intercom').length > 0 ||
      iframedInSeismic
    ) {
      window.Intercom('shutdown');
    } else {
      window.Intercom('boot');
    }
  }
}

window.addEventListener(
  'load',
  function onLoadedCallback() {
    toggleIntercom();
  },
  false,
);

window.addEventListener('storage', function storageCallback(event) {
  if (
    event.storageArea === sessionStorage &&
    event.key === 'iframedInSeismic' &&
    sessionStorage.getItem('iframedInSeismic') === 'true'
  ) {
    toggleIntercom();
  }
});
